import script from "./SingleElemDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleElemDisplay.vue?vue&type=script&setup=true&lang=js"

import "./SingleElemDisplay.vue?vue&type=style&index=0&id=2dfdbdca&scoped=true&lang=css"

import exportComponent from "/home/runner/work/prayerwall/prayerwall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dfdbdca"]])

export default __exports__